import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRequestService } from '../shared/api-request.service';
import { AuditsModel } from './audits.model';
import { ApiResponseModel } from '../models/api-response.model';

type ResponseAudit = ApiResponseModel<AuditsModel>;
type ResponseAudits = ApiResponseModel<AuditsModel[]>;

@Injectable({
  providedIn: 'root'
})
export class AuditsService {
  constructor(private api: ApiRequestService) {}

  public post(audit: AuditsModel): Observable<ResponseAudit> {
    audit.template = true;
    return this.api.makeRequestObservable('post', 'v1/audits', audit);
  }

  public remove(ids: number[]): Observable<{}> {
    return this.api.makeRequestObservable('delete', `v1/audits/${ids}`);
  }

  public find(id: number): Observable<ResponseAudit> {
    return this.api.makeRequestObservable('get', `v1/audits/${id}`);
  }

  public get(template: boolean): Observable<ResponseAudits> {
    return this.api.makeRequestObservable('get', `v1/audits?template=${template}`);
  }

  public put(audits: AuditsModel): Observable<{}> {
    return this.api.makeRequestObservable('put', `v1/audits/${audits.id}`, audits);
  }

  public exportPdf(id: number): Promise<any> {
    return this.api.makeDownloadRequest(`v1/audits/export/${id}`);
  }

  public getContacts(id: number, page?: number) {
    return this.api.makeRequestObservable('get', `v1/audits/contacts/${id}${page ? `?page=${page}` : ''}`);
  }
}
